module.exports = __webpack_public_path__ + "assets/images/conversation.4c94c4e752ae974118e7142b9f4e839e.png";